import {NAME} from "../constant";

export const getProductName = (data) => {
    return {type: NAME, data};
}
